export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEMVW5pR0ItVUNTMi1IYQ8gFACEVhEAhFeDfgC8HJtbAIQ/AACEPgUHhEgAAYRSAQC8GgABhEYAAYRQg51pAIRCBgGERAIAhD0BALwbCwGEQEEJ/x28HAHvMxvvMgEAAe8NGwkBAADvBIEEDA==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/UniGB-UCS2-V.bcmap
// module id = 695
// module chunks = 502